import React, { useState } from "react";

const plans = [
  {
    name: "Starter Plan",
    price: "$10",
    desc: "Best for small teams to manage employees and streamline operations.",
    features: ["Employee Management", "Basic Attendance Tracking", "Limited Roles & Permissions", "Email Support"],
    popular: false,
  },
  {
    name: "Professional Plan",
    price: "$15",
    desc: "For growing teams ready to scale operations efficiently with confidence.",
    features: ["Everything in Starter", "Advanced Roles & Permissions", "Real-Time Session Tracking", "Detailed Attendance Insights", "Priority Support"],
    popular: true,
  },
  {
    name: "Enterprise Plan",
    price: "$50",
    desc: "For growing teams and large organizations to scale operations with confidence.",
    features: ["All Pro Features", "Unlimited Employees", "Advanced Analytics & Reports", "Dedicated Account Manager", "Custom Integrations", "24/7 Premium Support"],
    popular: false,
  },
];

export default function Pricing() {
  const [selected, setSelected] = useState("Professional Plan");

  return (
    <section style={s.section}>
      <style>{`
        .pr-grid {
          max-width:1000px; margin:0 auto;
          display:grid; grid-template-columns:repeat(3,1fr);
          gap:24px; align-items:stretch;
        }
        @media(max-width:900px){
          .pr-grid { grid-template-columns:1fr; max-width:440px; }
        }
        @media(max-width:480px){
          .pr-grid { max-width:100%; }
        }
      `}</style>

      <div style={s.tag}><span style={{ color:"#3d372e", fontSize:10, marginRight:10 }}>⬤</span> Pricing Plan</div>
      <h2 style={s.h2}>Simple, Transparent <span style={s.gold}>Pricing</span></h2>

      <div className="pr-grid">
        {plans.map((p) => {
          const isSelected = selected === p.name;
          return (
            <div key={p.name} style={{ ...s.card, ...(isSelected ? s.active : {}) }}>
              {p.popular && <div style={s.badge}>Most Popular</div>}
              <div style={s.planName}>{p.name}</div>
              <div style={s.price}>{p.price} <span style={s.per}>/per month</span></div>
              <p style={s.desc}>{p.desc}</p>
              <button onClick={() => setSelected(p.name)} style={{ ...s.btn, ...(isSelected ? s.btnActive : {}) }}>
                Get Started
              </button>
              <div style={s.featureLabel}>Features:</div>
              <ul style={s.list}>
                {p.features.map((f) => (
                  <li key={f} style={s.li}><span style={s.check}>✓</span>{f}</li>
                ))}
              </ul>
            </div>
          );
        })}
      </div>
    </section>
  );
}

const s = {
  section:      { padding:"80px 24px", background:"#080D20", fontFamily:"'Segoe UI', sans-serif" },
  tag:          { textAlign:"center", color:"#6b7280", fontSize:13, fontWeight:600, marginBottom:10 },
  h2:           { textAlign:"center", fontSize:"clamp(24px,4vw,40px)", fontWeight:700, color:"#fff", marginBottom:48 },
  gold:         { color:"#998046" },
  card:         { border:"1px solid #1e2e45", borderRadius:16, padding:"40px 28px", position:"relative", background:"#13202D", display:"flex", flexDirection:"column" },
  active:       { border:"2px solid #998046", boxShadow:"0 8px 32px rgba(153,128,70,0.15)" },
  badge:        { position:"absolute", top:-14, left:"50%", transform:"translateX(-50%)", background:"#080D20", color:"#998046", fontSize:12, fontWeight:700, borderRadius:99, padding:"4px 16px", whiteSpace:"nowrap" },
  planName:     { fontSize:15, fontWeight:600, color:"#fff", marginBottom:8 },
  price:        { fontSize:36, fontWeight:700, color:"#fff", marginBottom:8 },
  per:          { fontSize:14, fontWeight:400, color:"#6b7280" },
  desc:         { fontSize:13, color:"#818A9D", marginBottom:20, lineHeight:1.6 },
  btn:          { width:"100%", padding:"12px", borderRadius:8, border:"2px solid #1e2e45", background:"#fff", color:"#080e21", fontWeight:700, fontSize:14, cursor:"pointer", marginBottom:20 },
  btnActive:    { background:"#998046", color:"#fff", border:"2px solid #998046" },
  featureLabel: { fontSize:13, fontWeight:600, color:"#818A9D", marginBottom:10 },
  list:         { listStyle:"none", padding:0, margin:0, display:"flex", flexDirection:"column", gap:10, flex:1 },
  li:           { display:"flex", alignItems:"center", gap:8, fontSize:13, color:"#818A9D" },
  check:        { color:"#1d7ed8", fontWeight:700 },
};
